// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: io/datetime_output.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

/** [Internal] Output from a datetime request to Hank. */
export interface DatetimeOutput {
  /** Hanks local date/time in RFC 3339 format. */
  datetime: string;
}

function createBaseDatetimeOutput(): DatetimeOutput {
  return { datetime: "" };
}

export const DatetimeOutput: MessageFns<DatetimeOutput> = {
  encode(message: DatetimeOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.datetime !== "") {
      writer.uint32(10).string(message.datetime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatetimeOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatetimeOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.datetime = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatetimeOutput {
    return { datetime: isSet(object.datetime) ? globalThis.String(object.datetime) : "" };
  },

  toJSON(message: DatetimeOutput): unknown {
    const obj: any = {};
    if (message.datetime !== "") {
      obj.datetime = message.datetime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatetimeOutput>, I>>(base?: I): DatetimeOutput {
    return DatetimeOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatetimeOutput>, I>>(object: I): DatetimeOutput {
    const message = createBaseDatetimeOutput();
    message.datetime = object.datetime ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
